import apiTool from './index';

const LOGIN_URL = 'api-token-auth/';

export default {
  getTokenFromLogin(payload) {
    return apiTool.postforlogin(LOGIN_URL, payload);
  }
};
